export default __webpack_public_path__ + "static/media/161244087210957926.82dd52d0.png";